import { apiAppointmentSummaryModel, appointmentSummaryModel } from './../models/dashboard.model';
import { ServiceLocationTime } from '../models/serviceLocation.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse, ResponseStatus, PayloadResponse } from '../models/response.model';
import { map } from 'rxjs/operators';
import { AppointmentFormModel } from '../models/appointment-form.model';
import { ServiceLocation } from '../models/serviceLocation.model';
import { CommonService } from './common.service'
import moment from 'moment'
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient,
    private commonService: CommonService,
  ) {

  }

  // customer
  apiPushMessageOnProcess(body): Observable<any> {    
    return this.http.post<any>(environment.endpointBackend + '/api/line/claim/pushCustomerOnprocess', body).pipe(
      map(
        payload => {
          switch (payload.response_code) {
            case ('40000'):
              return payload
            default:
              return null
          }
        }
      )
    )
  }
    // customer
    apiPushMessageCancel(body:{"electronic_channel":number}): Observable<any> {
      return this.http.post<any>(environment.endpointBackend + '/api/line/claim/pushCustomerAppointmentCancel', body).pipe(
        map(
          payload => {
            switch (payload.response_code) {
              case ('40000'):
                return payload
              default:
                return null
            }
          }
        )
      )
    }
// customer
apiPushDealerConfirm(body): Observable<any> {
    return this.http.post<any>(environment.endpointBackend + '/api/line/claim/pushDealerConfirm', body).pipe(
      map(
        payload => {
          switch (payload.response_code) {
            case ('40000'):
              return payload
            default:
              return null
          }
        }
      )
    )
  }
  // customer
apiPushMessageInvite(body): Observable<any> {
  return this.http.post<any>(environment.endpointBackend + '/api/line/claim/pushMessageInvite', body).pipe(
    map(
      payload => {
        switch (payload.response_code) {
          case ('40000'):
            return payload
          default:
            return null
        }
      }
    )
  )
}
  // dealer
  apiPushMessageDealerRemainder(body): Observable<any> {
    return this.http.post<any>(environment.endpointBackend + '/api/line/dealer/notification', body).pipe(
      map(
        payload => {
          switch (payload.response_code) {
            case ('40000'):
              return payload
            default:
              return null
          }
        }
      )
    )
  }
// dealer
apiPushMessageDealerCancelAppointment(body): Observable<any> {
  return this.http.post<any>(environment.endpointBackend + '/api/line/dealer/notificationCancel', body).pipe(
    map(
      payload => {
        switch (payload.response_code) {
          case ('40000'):
            return payload
          default:
            return null
        }
      }
    )
  )
}
  
}
